// extracted by mini-css-extract-plugin
module.exports = {"link-author-checkbox":"image-details_link-author-checkbox__4u4Nm","image-details-container":"image-details_image-details-container__2HZ3z"};